export default __webpack_public_path__ + "static/Sentry-c79af9e655dba4703f7a865eba48174e.png";